export class PreIronedDetail{
    storeName: string;
    sku: string;
    total: number;
    concept: string;
    date: string;
    sap: string;
    wareHouse: string;
}